import { customerTypes, leadStages } from "../config/options.js";
import { CustomerTable, HiddenCustomerTable } from "../components/crmTables.jsx";
import { Topbar } from "../components/ui.jsx";

export function CustomersView({
  user,
  users,
  customers,
  verticalOptions = [],
  hiddenCustomers = [],
  filters,
  setFilters,
  openCustomer,
  openCall,
  openVisit,
  openOrder,
  openMessage,
  hideCustomer,
  restoreCustomer,
  requestCustomerDeletion,
  openEmployee,
}) {
  return (
    <>
      <Topbar title="Prospects" subtitle="Structured customer capture with lead status and follow-up ownership.">
        <button className="primary-btn" onClick={() => openCustomer(null)}>
          Add Prospect
        </button>
      </Topbar>
      <section className="panel">
        <div className="filters">
          <input
            placeholder="Search name, phone, interest, vertical"
            value={filters.search}
            onChange={(event) => setFilters((current) => ({ ...current, search: event.target.value }))}
          />
          <select value={filters.stage} onChange={(event) => setFilters((current) => ({ ...current, stage: event.target.value }))}>
            <option value="">All stages</option>
            {leadStages.map((stage) => (
              <option key={stage}>{stage}</option>
            ))}
          </select>
          <select value={filters.type} onChange={(event) => setFilters((current) => ({ ...current, type: event.target.value }))}>
            <option value="">All types</option>
            {customerTypes.map((type) => (
              <option key={type}>{type}</option>
            ))}
          </select>
          <select value={filters.vertical || ""} onChange={(event) => setFilters((current) => ({ ...current, vertical: event.target.value }))}>
            <option value="">All verticals</option>
            {verticalOptions.map((vertical) => (
              <option key={vertical}>{vertical}</option>
            ))}
          </select>
          <button className="ghost-btn" onClick={() => setFilters({ search: "", stage: "", type: "", vertical: "" })}>
            Clear
          </button>
        </div>
        <CustomerTable
          user={user}
          users={users}
          customers={customers}
          openCustomer={openCustomer}
          openCall={openCall}
          openVisit={openVisit}
          openOrder={openOrder}
          openMessage={openMessage}
          hideCustomer={hideCustomer}
          requestCustomerDeletion={requestCustomerDeletion}
          openEmployee={openEmployee}
        />
      </section>
      {hiddenCustomers.length ? (
        <section className="panel spaced">
          <h2>Hidden Prospects</h2>
          <HiddenCustomerTable customers={hiddenCustomers} users={users} restoreCustomer={restoreCustomer} openCustomer={openCustomer} openEmployee={openEmployee} />
        </section>
      ) : null}
    </>
  );
}
